module.exports = "https://static.wmbcdn.com/uniweb/images/2bf3e2ba16df60e9d27903d42d7345b9.svg";